import { ChevronUpIcon } from '@mote/assets/icons'
import styled, { css } from '@xstyled/styled-components'
import { Block } from '../../block/block'
import { TableCell } from '../../table/components'
import { VisuallyHidden } from '../../visuallyHidden/visuallyHidden'
import { useDataTable } from '../dataTable.context'

export const DataTableHeaderCell = ({ header }) => {
  const { getHeaderCellProps } = useDataTable()
  let { isSortable, item, sortProps, ...props } = getHeaderCellProps(header)

  if (isSortable) {
    item = (
      <SortButton {...sortProps}>
        {item}
        {sortProps.sortDirection && (
          <VisuallyHidden as='span'>
            {sortProps.sortDirection === 'asc'
              ? 'Sorted ascending'
              : 'Sorted descending'}
          </VisuallyHidden>
        )}
        <ChevronUpIcon
          color='currentColor'
          width='1.5em'
          height='1.5em'
          aria-hidden={true}
          focusable={false}
        />
      </SortButton>
    )
  }

  return (
    <TableCell
      key={header.id}
      sortDirection={sortProps.sortDirection}
      {...props}
    >
      {item}
    </TableCell>
  )
}

const sortVisibilityStyles = css`
  svg {
    visibility: visible;
    opacity: 1;
  }
`

const SortButton = styled(Block).attrs({
  align: 'center',
  'aria-label': 'Sort'
})`
  user-select: none;
  outline: none;
  transition: opacity 150ms;

  svg {
    opacity: 0;
    visibility: hidden;
    transform: rotate(0);
    transition: all 150ms;
  }

  &[data-sort='desc'] {
    svg {
      transform: rotate(180deg);
    }
  }

  &:focus {
    opacity: 0.7;
  }

  @media (hover: hover) {
    &:hover {
      opacity: 0.7;
    }
  }

  ${({ sortDirection }) =>
    !sortDirection
      ? css`
          @media (hover: hover) {
            &:hover {
              ${sortVisibilityStyles}
            }
          }
        `
      : sortVisibilityStyles}
`
